module.exports = __webpack_public_path__ + "static/img/remesas_envios_category.df5ac7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/old/remesas_envios_category.jpg
// module id = +rBK
// module chunks = 1